// Resolves an issuing carrier name to its brand / parent group.
// Surplus-lines specialty insurance routinely shows the legal issuing
// entity on the policy declarations page (e.g., "Indian Harbor Insurance
// Company") while the broker discusses the brand ("AXA XL"). This helper
// gives advisors and the AI both names so reports read naturally.

import carrierGroups from '../data/carrierGroups.json'

const CARRIER_PATTERNS = (carrierGroups.groups || []).map(g => ({
  ...g,
  // Compile case-insensitive regex once. Pipe-separated patterns supported.
  regex: new RegExp(`(?:${g.issuingPattern})`, 'i')
}))

// Returns { brand, parentGroup, context, issuingName } when a match is found,
// or null if the carrier doesn't map to a known group. Safe to call with any
// string or null/undefined.
export function resolveCarrierGroup(carrierText) {
  if (!carrierText || typeof carrierText !== 'string') return null
  const text = carrierText.trim()
  if (!text) return null
  for (const g of CARRIER_PATTERNS) {
    if (g.regex.test(text)) {
      return {
        brand: g.brand,
        parentGroup: g.parentGroup,
        context: g.context,
        issuingName: g.issuingName
      }
    }
  }
  return null
}

// Formats a carrier label for display. If the carrier maps to a known brand
// AND the brand is meaningfully different from the issuing name, returns
// "Issuing Name (Brand)". Otherwise returns the original.
export function formatCarrierWithBrand(carrierText) {
  if (!carrierText) return ''
  const group = resolveCarrierGroup(carrierText)
  if (!group) return carrierText
  // If the carrier text already includes the brand, don't duplicate
  const lower = carrierText.toLowerCase()
  if (group.brand && !lower.includes(group.brand.toLowerCase().split(/[\s/]/)[0].toLowerCase())) {
    return `${carrierText} (${group.brand})`
  }
  return carrierText
}
